import { useContext } from "react";
import { Flex, Text, LegacyText, Box } from "flicket-ui";
import { useRouter } from "next/router";
import useSWR from "swr";

import {
  Layout,
  Footer,
  BottomBar,
  Menu,
  Seo,
  PageContainer,
  SlateRenderer,
  Status,
} from "~components";
import { EventTitle } from "~components/events/events.Title";
import { BaseContext } from "~context";
import { sdk } from "~lib";
import BaseHeader from "~components/common/common.BaseHeader";

const getEvent = async (_: string, orgId: string, eventId) =>
  sdk({ orgId })
    .event({ id: eventId })
    .then((res) => res.event);

const swrConfig = {
  shouldRetryOnError: false,
};

const TermsAndConditions = () => {
  const router = useRouter();
  const { organization } = useContext(BaseContext);

  const { data: event, error } = useSWR(
    ["event", organization.id, router.query.eventId],
    getEvent,
    swrConfig
  );

  const pageTitle = (() => {
    let pre = "";

    if (event?.title) {
      pre = event.title + ": ";
    }
    return pre + "Terms and Conditions";
  })();

  const termsAndConditions =
    event?.termsAndConditions ?? organization.termsAndConditions;

  return (
    <>
      <Seo title={pageTitle} description={undefined} />
      <Menu />
      <Status loading={!event && !error} error={error}>
        <Flex flexDirection="column" flex={1}>
          {/* Mobile */}
          <Box d={{ _: "block", md: "none" }} pb={8}>
            <BaseHeader
              title={event?.title}
              subTitle={"Terms and conditions"}
              onClickBack={() => {
                void router.push(`/events/${event?.id}`);
              }}
            />
          </Box>

          <Flex
            flexDirection="column"
            flex={1}
            maxH={{ _: "calc(100vh - 73px)", md: "unset" }}
            overflowY={{ _: "auto", md: "visible" }}
          >
            <Layout layoutType="overlay">
              <PageContainer
                backgroundImage={event?.backgroundImage}
                backgroundImageFullPage={event?.backgroundImageFullPage}
                bannerImage={null}
                footer={<Footer />}
                title={
                  <EventTitle
                    backToLinkText="Back to Event"
                    backToLink={`/events/${event?.id}`}
                    isSinglePage={false}
                    title={pageTitle}
                    startDate={event?.startDate}
                    endDate={event?.endDate}
                    venue={event?.venue}
                  />
                }
              >
                {termsAndConditions ? (
                  <SlateRenderer value={termsAndConditions} />
                ) : (
                  <LegacyText mb={{ _: 1, md: 2 }}>
                    Terms and Conditions coming soon!
                  </LegacyText>
                )}
              </PageContainer>
            </Layout>
          </Flex>
        </Flex>
        <BottomBar />
      </Status>
    </>
  );
};

export default TermsAndConditions;
